import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

const TopNavigation = ({
  isBusy,
  onCreateClick,
  isValid,
  setOpenModalUpload,
}) => {
  return (
    <>
      <Button
        compact
        primary
        onClick={onCreateClick}
        //disabled={isBusy || !isValid}
      >
        Create CFDI
      </Button>
    </>
  );
};

TopNavigation.propTypes = {
  isBusy: PropTypes.bool,
  onCreateClick: PropTypes.func,
  isValid: PropTypes.bool,
};

export default TopNavigation;
